<template>
	<div class="box">
		<!-- <keep-alive>
            <router-view v-if="$route.name=='homePage'"></router-view>
        </keep-alive> -->
        <router-view></router-view>
	</div>
</template>

<script>
import storage from '@/utils/storage'
	export default{
		data(){
			return {

			}
		},
		created(){
			if(storage.localGet('token')){
				this.$store.commit('setUsername',storage.localGet('username'))
			}
		},
		computed:{
			setStorage(){
				return !!storage.localGet('token')
			}
		},
		methods:{
		}
	}
</script>

<style>
.box{
	height: 100%;
}
 #nprogress .bar {
	background: #ffffff !important;
}
</style>
